import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../../components/button';
import { ButtonToggleDirective } from './button-toggle.directive';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule
  ],
  declarations: [
    ButtonToggleDirective
  ],
  exports: [
    ButtonToggleDirective,
  ]
})
export class ButtonToggleModule {
}
